<div class="wrapper">
    <div class="avatar">
        @if (organization()?.organizationImageUrl; as organizationImageUrl) {
            <img [ngSrc]="organizationImageUrl" alt="Organization logo" width="35" height="35" loading="eager" />
        } @else {
            <div class="icon" [innerHTML]="organizationLogoIcon"></div>
        }
    </div>

    <div
        class="information"
        libTooltip
        [tooltip]="$safeNavigationMigration(organization()?.organizationName)"
        [position]="orgNameTooltipPosition()"
    >
        <span class="name">{{ organization()?.organizationName }}</span>
        <div class="role">{{ organization()?.userRoleDescription }}</div>
    </div>
</div>
